const dropdown1Id = '#mobileTableDropdown1';
const dropdown2Id = '#mobileTableDropdown2';

const dropdown1 = document.querySelector(dropdown1Id);
const dropdown2 = document.querySelector(dropdown2Id);

let selectedValueDropdown1 = dropdown1.querySelector(':checked')?.value || '';
let selectedValueDropdown2 = dropdown2.querySelector(':checked')?.value || '';

let notSelectedValue = '';

// Generate initial state - Disable option of other Dropdown & add Classes accordingly
const initialOption1 = document.querySelector(`${dropdown1Id} option[value*='${selectedValueDropdown2}']`);
if (initialOption1) initialOption1.disabled = true;

const initialOption2 = document.querySelector(`${dropdown2Id} option[value*='${selectedValueDropdown1}']`);
if (initialOption2) initialOption2.disabled = true;

// Get available options
document.querySelectorAll(`${dropdown1Id} > option`).forEach((option) => {
  if (option.value !== selectedValueDropdown1 && option.value !== selectedValueDropdown2) {
    notSelectedValue = option.value;
  }
});

function tableHandler(thisDropdown, thisDropdownValue, otherDropdownId) {
    const tempDropdownValue = thisDropdown.querySelector(':checked')?.value || '';

    if (thisDropdownValue === '1') {
        notSelectedValue = selectedValueDropdown1;
        selectedValueDropdown1 = tempDropdownValue;

        document.querySelectorAll(`div[data-mobile-dropdown-id='${tempDropdownValue}']`).forEach((el) => {
          el.classList.add('column--first-selected');
          el.classList.remove('column--second-selected');
          el.classList.remove('column--not-selected');
        });
    } else {
        notSelectedValue = selectedValueDropdown2;
        selectedValueDropdown2 = tempDropdownValue;

        document.querySelectorAll(`div[data-mobile-dropdown-id='${tempDropdownValue}']`).forEach((el) => {
          el.classList.add('column--second-selected');
          el.classList.remove('column--first-selected');
          el.classList.remove('column--not-selected');
        });
    }

    document.querySelectorAll(`${otherDropdownId} > option`).forEach((option) => {
      option.disabled = option.value === tempDropdownValue;
    });

    document.querySelectorAll(`div[data-mobile-dropdown-id='${notSelectedValue}']`).forEach((el) => {
      el.classList.add('column--not-selected');
      el.classList.remove('column--first-selected');
      el.classList.remove('column--second-selected');
    });
}

dropdown1.addEventListener('change', () => {
  tableHandler(dropdown1, '1', dropdown2Id);
});

dropdown2.addEventListener('change', () => {
  tableHandler(dropdown2, '2', dropdown1Id);
});
